var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"budget-filter-tourists",class:`budget-filter-tourists_${_vm.size}`},[_vm._v("\n  Цена: "+_vm._s(_setup.touristGroupText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }